import { GDPRConfig } from '@ecg-marktplaats/gdpr-consent-string';
import nlNL from '../../locales/nl-NL/translation.json';
import nlBE from '../../locales/nl-BE/translation.json';
import frBE from '../../locales/fr-BE/translation.json';

/**
 * Gets translations using the locale value from the global `window.GDPRConfig`
 * object.
 */
const getTranslations = () => {
  const translations = {
    'nl-NL': nlNL.gdprConsentBanner,
    'nl-BE': nlBE.gdprConsentBanner,
    'fr-BE': frBE.gdprConsentBanner,
  };

  return translations[GDPRConfig.locale];
};

export default getTranslations;
